import Service, { service } from '@ember/service';

export default class KineticShiftRepo extends Service {
  @service store;

  kineticShifts = this.store.peekAll('kinetic-shift');
}
